import React from 'react';
import PropTypes from 'prop-types';
import Banner, { BANNER_TYPES } from '../Banner';
import CurrencyUtils from '@wix/wixrest-utils/dist/CurrencyUtils';
import styles from './AddressInformationBanner.scss';

export default function AddressInformationBanner({ organization, t, bannerInfo, deliveryInfo }) {
  const deliveryInfoCharge = deliveryInfo && deliveryInfo.charge ? deliveryInfo.charge : 0;
  const deliveryCharge =
    deliveryInfo && CurrencyUtils.toStr(deliveryInfoCharge / 100, organization.currency, organization.locale);
  return (
    <Banner type={bannerInfo.type}>
      {bannerInfo.type === BANNER_TYPES.SUCCESS ? (
        t('phoneordering_customerinfo_ordertype_deliverycharge_inarea', { actualDeliveryCharge: deliveryCharge })
      ) : (
        <div>
          <div style={{fontWeight:'normal'}}>{bannerInfo.mainText}</div>
          <div>{bannerInfo.text}</div>
        </div>
      )}
    </Banner>
  );
}

AddressInformationBanner.displayName = 'AddressInformationBanner';
AddressInformationBanner.propTypes = {
  organization: PropTypes.object,
  bannerInfo: PropTypes.object,
  deliveryInfo: PropTypes.object,
  t: PropTypes.func,
};
